import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScheduleModel } from './schedule.model';
import { environment } from '../../../environments/environment';

const BASE_ENDPOINT = '/schedule';

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<ScheduleModel[]> {
    return this.http.get<ScheduleModel[]>(environment.apiUrl + BASE_ENDPOINT);
  }

  getCalendarEvents(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + BASE_ENDPOINT + '/calendar');
  }

  getById(id: number): Observable<ScheduleModel> {
    return this.http.get<ScheduleModel>(`${environment.apiUrl + BASE_ENDPOINT}/${id}`);
  }

  create(schedule: ScheduleModel): Observable<ScheduleModel> {
    return this.http.post<ScheduleModel>(environment.apiUrl + BASE_ENDPOINT, schedule);
  }

  update(schedule: ScheduleModel): Observable<ScheduleModel> {
    return this.http.put<ScheduleModel>(
      environment.apiUrl + BASE_ENDPOINT + '/' + schedule.id,
      schedule
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl + BASE_ENDPOINT}/${id}`);
  }
}